import { c as _c } from "react/compiler-runtime";
import { RoundupDriverGroupEnum } from '@repo/contracts/marketplace/offers/enums';
import { css } from '@repo/pandacss/css';
import { Flex } from '@repo/pandacss/jsx';
import type { WithCss } from '@repo/pandacss/types';
import { InfoTooltip, type InfoTooltipProps } from '@repo/ui/composites/InfoTooltip';
import { Typography } from '@repo/ui/Typography';
import type { DriverType } from '../types';
import { DriverValueTooltip } from './DriverValueTooltip';
import { SanitizedHtml } from './SanitizedHtml/SanitizedHtml';
const driverValueTooltipExtraProps: Partial<InfoTooltipProps> = {
  triggerCss: css.raw({
    minHeight: '[0]',
    minWidth: '[0]',
    width: '[fit-content]' // MUI TooltipTrigger parity: 18px icon + borders → 20px button
  }),
  triggerWrapperCss: css.raw({
    height: '[22px]'
  }),
  triggerIconCss: css.raw({
    boxSize: '[18px]'
  })
};
export const Driver = t0 => {
  const $ = _c(42);
  const {
    driver,
    driverGroup,
    css: cssProp,
    segmentActionSection,
    isLtoHighlightingEnabled: t1
  } = t0;
  t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [RoundupDriverGroupEnum.Rewards, RoundupDriverGroupEnum.Subprime];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const isRewardsOrSubprimeRU = t2.includes(driverGroup);
  let t3;
  if ($[1] !== driver.valueTooltip) {
    t3 = driver.valueTooltip ? <SanitizedHtml html={driver.valueTooltip} /> : undefined;
    $[1] = driver.valueTooltip;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const valueTooltip = t3;
  let t4;
  if ($[3] !== driver.label) {
    t4 = driver.label.replace(/\s/g, "").toLocaleLowerCase();
    $[3] = driver.label;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const driverKey = t4;
  const LTOIntroOffer = driver.id === "introOffer" && "ltoValue" in driver && driver.ltoValue;
  let t5;
  if ($[5] !== cssProp) {
    t5 = {
      ...cssProp,
      pt: "2",
      flexDirection: "column",
      containerName: "product-card-driver",
      containerType: "inline-size"
    };
    $[5] = cssProp;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      alignItems: "center",
      flexWrap: "wrap",
      gap: "1",
      position: "relative",
      width: "[fit-content]"
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      color: "neutral.darker",
      mb: "1"
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== driver.label) {
    t8 = <Typography data-testid="product-card-driver-label" variant="body.small" css={t7}>{driver.label}</Typography>;
    $[9] = driver.label;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = `${driver.label} information`;
  let t10;
  if ($[11] !== driver.labelTooltip || $[12] !== driver.labelTooltipMaxWidth || $[13] !== t9) {
    t10 = <InfoTooltip ariaLabel={t9} text={driver.labelTooltip} popupMaxWidth={driver.labelTooltipMaxWidth} />;
    $[11] = driver.labelTooltip;
    $[12] = driver.labelTooltipMaxWidth;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t8) {
    t11 = <Flex css={t6}>{t8}{t10}</Flex>;
    $[15] = t10;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== LTOIntroOffer) {
    t12 = LTOIntroOffer && {
      alignItems: "flex-end"
    };
    $[18] = LTOIntroOffer;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12) {
    t13 = {
      alignItems: "center",
      flexWrap: "wrap",
      gap: "1",
      position: "relative",
      width: "[100%]",
      ...t12
    };
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== LTOIntroOffer || $[23] !== driver.value) {
    t14 = !LTOIntroOffer ? <Typography as="div" data-testid="product-card-driver-value" variant="text.bold" css={{
      color: "[#141414]",
      fontSize: {
        base: "[15px]",
        _pcMd: "[16px]"
      },
      lineHeight: {
        base: "[140% !important]",
        _pcMd: "150%"
      },
      wordBreak: "break-word"
    }}>{driver.value}</Typography> : <LTOIntroOffer />;
    $[22] = LTOIntroOffer;
    $[23] = driver.value;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const t15 = `More information about ${driver.label}`;
  const t16 = isRewardsOrSubprimeRU && driverValueTooltipExtraProps;
  let t17;
  if ($[25] !== driverKey || $[26] !== segmentActionSection || $[27] !== t15 || $[28] !== t16 || $[29] !== valueTooltip) {
    t17 = <DriverValueTooltip driverKey={driverKey} segmentActionSection={segmentActionSection} ariaLabel={t15} text={valueTooltip} {...t16} />;
    $[25] = driverKey;
    $[26] = segmentActionSection;
    $[27] = t15;
    $[28] = t16;
    $[29] = valueTooltip;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t13 || $[32] !== t14 || $[33] !== t17) {
    t18 = <Flex css={t13}>{t14}{t17}</Flex>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== driver.description) {
    t19 = driver.description && <Typography variant="text.small" css={{
      color: "grey.500",
      textTransform: "capitalize"
    }}>{driver.description}</Typography>;
    $[35] = driver.description;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t11 || $[38] !== t18 || $[39] !== t19 || $[40] !== t5) {
    t20 = <Flex css={t5}>{t11}{t18}{t19}</Flex>;
    $[37] = t11;
    $[38] = t18;
    $[39] = t19;
    $[40] = t5;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  return t20;
};